module.exports = __webpack_public_path__ + "static/media/weningsih-blue.6c3fb49a.png";